// src/tasksAdmin/index.js — ✅ Tasks (Phase C3): the managers-app composer +
// compliance board. ToyTalk "Do" replacement, oversight surface.
//
// HEAD OFFICE composes (title/details/priority/audience/recurrence — one-off
// due date, daily, weekly weekday-picks, monthly day-of-month — valid window,
// photo-evidence toggle) and archives; both HO and AREA MANAGERS read the
// date-ranged compliance board (per-store % + what's missing — the ToyTalk
// roll-up). The Worker enforces every gate (compose = role admin; compliance =
// AM auto-scoped); this bundle only decides what to SHOW. Auth = admin Bearer.

import { loadList } from '../shared/load-failure.js';   // v131.76 - say WHY a list is empty

import { areaChipsHtml, pickAreaStores } from '../shared/areaPick.js';
import { openStoredFile } from '../shared/open-file.js';   // v129.112 — ONE opener (Head Office's PDF)
// v129.113 — SEVERAL reference files per task (three Head Office colleagues, 13 Aug).
import { MAX_COMPOSE_FILES, addAttachmentFiles, composeChipsHtml, attachLinksHtml, openFromPayload, wireDropZone, paintFileState, refusedSendOk } from '../shared/attachments-ui.js';

function esc(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function api(path, opts) {
  opts = opts || {};
  var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
  var headers = { 'Content-Type': 'application/json' };
  var tk = (typeof DB !== 'undefined' && DB.getToken) ? DB.getToken() : null;
  if (tk) headers['Authorization'] = 'Bearer ' + tk;
  return fetch(base + path, { method: opts.method || 'GET', headers: headers, body: opts.body, cache: 'no-store' });
}
function toast(msg, kind) {
  if (typeof showToast !== 'undefined') showToast(msg, kind || 'success');
}

var _tasks = [];
var _isHO = false;
var _amMode = false;   // v126.81 — area_manager: composer on, scope locked to their area
var _editingId = null;           // v126.68 — the task being edited (composer in edit mode)

function root() { return document.getElementById('tasksAdminRoot'); }

var _styled = false;
function ensureStyles() {
  if (_styled) return;
  _styled = true;
  var css = '' +
    '#tasksAdminRoot .ta-wrap{max-width:760px}' +
    '#tasksAdminRoot .ta-compose{background:var(--card);border:1px solid var(--border);border-radius:12px;padding:16px;margin-bottom:16px}' +
    '#tasksAdminRoot .ta-compose h3{margin:0 0 10px;font-size:15px;color:var(--brand,#009E3D)}' +
    '#tasksAdminRoot .ta-in{width:100%;padding:9px 10px;border:1px solid var(--border-strong);border-radius:8px;font-size:13.5px;margin-bottom:8px;box-sizing:border-box;font-family:inherit}' +
    '#tasksAdminRoot textarea.ta-in{min-height:80px;resize:vertical}' +
    '#tasksAdminRoot .ta-row{display:flex;gap:10px;align-items:center;flex-wrap:wrap;margin-bottom:8px;font-size:13px}' +
    '#tasksAdminRoot .ta-stores{max-height:140px;overflow-y:auto;border:1px solid var(--border);border-radius:8px;padding:8px;font-size:12.5px;columns:2;margin-bottom:8px}' +
    '#tasksAdminRoot .ta-go{background:var(--brand,#009E3D);color:#fff;border:none;border-radius:8px;padding:10px 18px;font-weight:700;font-size:13.5px;cursor:pointer}' +
    '#tasksAdminRoot .ta-card{background:var(--card);border:1px solid var(--border);border-radius:10px;padding:12px 14px;margin-bottom:10px}' +
    '#tasksAdminRoot .ta-title{font-weight:700;font-size:14.5px;color:var(--text,#111b21);display:flex;gap:6px;align-items:center;flex-wrap:wrap}' +
    '#tasksAdminRoot .ta-chip{font-size:10px;font-weight:800;border-radius:8px;padding:1px 7px;color:#fff}' +
    '#tasksAdminRoot .ta-chip.u{background:#e53935}#tasksAdminRoot .ta-chip.h{background:#fb8c00}' +
    '#tasksAdminRoot .ta-arch{font-size:10px;font-weight:800;background:var(--surface-3);color:var(--sub,#546e7a);border-radius:8px;padding:1px 7px}' +
    '#tasksAdminRoot .ta-meta{font-size:11.5px;color:var(--tiny,#8696a0);margin-top:4px}' +
    '#tasksAdminRoot .ta-btn{background:var(--bg,#f0f2f5);border:none;border-radius:8px;padding:6px 12px;font-size:12.5px;font-weight:600;cursor:pointer;color:var(--text,#111b21);margin-top:8px;margin-inline-end:6px}' +
    '#tasksAdminRoot .ta-board{background:var(--card);border:1px solid var(--border);border-radius:12px;padding:16px;margin-bottom:16px}' +
    '#tasksAdminRoot .ta-bar{height:8px;border-radius:4px;background:var(--surface-3);overflow:hidden;margin:4px 0 8px}' +
    '#tasksAdminRoot .ta-fill{height:100%;background:var(--brand,#009E3D)}' +
    '#tasksAdminRoot .ta-store{font-size:12.5px;margin-bottom:8px}' +
    '#tasksAdminRoot .ta-names{font-size:11.5px;color:var(--sub,#546e7a);margin-top:2px}';
  var el = document.createElement('style');
  el.id = 'tasksAdminStyles';
  el.textContent = css;
  document.head.appendChild(el);
}

function storeOptions() {
  var names = [];
  try {
    if (typeof ALL_STORES !== 'undefined' && Array.isArray(ALL_STORES)) {
      names = ALL_STORES.map(function (s) { return typeof s === 'string' ? s : (s && s.name); }).filter(Boolean);
    }
  } catch (e) { /* audience stays "all" */ }
  return names;
}

// v126.74 (Head Office's request #2) — countries derived from the admin.html inline
// store-lookup core (getStoreCountry), same as newsAdmin.
function countryOptions() {
  var out = [];
  try {
    if (typeof getStoreCountry === 'function') {
      storeOptions().forEach(function (n) {
        var c = getStoreCountry(n);
        if (c && out.indexOf(c) === -1) out.push(c);
      });
    }
  } catch (e) { /* no countries — option hidden */ }
  return out.sort();
}

function render() {
  ensureStyles();
  var acct = (typeof currentAdmin !== 'undefined' && currentAdmin) ? currentAdmin : null;
  var role = acct ? String(acct.role).toLowerCase() : '';
  _isHO = role === 'admin';
  _amMode = role === 'area_manager';   // v126.81 (an area manager) — AMs compose too, area-scoped
  bindPaste();   // v126.72 — paste a screenshot into the composer
  paint();
  refresh();
}

// v126.81 — the stores an AREA MANAGER may target: their own area's list
// (the AREA_STORE_MAP pattern, admin.html core). Falls back to all stores if
// the map has no entry — the Worker enforces the real boundary either way.
function amStoreOptions() {
  try {
    var area = (typeof currentAdmin !== 'undefined' && currentAdmin) ? currentAdmin.area : null;
    if (area != null && typeof AREA_STORE_MAP !== 'undefined' && Array.isArray(AREA_STORE_MAP[area]) && AREA_STORE_MAP[area].length) {
      return AREA_STORE_MAP[area].slice().sort();
    }
  } catch (e) { /* fall through */ }
  return storeOptions();
}

// v126.81 — may THIS viewer manage (edit/archive) this task? HO: any. AM: only
// a task aimed at picked stores that are ALL in their area (mirrors the
// Worker's amAudienceProblem rule — the server is authoritative).
function canManageTask(t) {
  if (_isHO) return true;
  if (!_amMode || !t || t.audience !== 'stores' || !Array.isArray(t.stores) || !t.stores.length) return false;
  var mine = {};
  amStoreOptions().forEach(function (n) { mine[n] = true; });
  return t.stores.every(function (n) { return mine[n]; });
}

// v131.76 - a failed load must not render as an empty list. See
// src/shared/load-failure.js for the incident this comes from.
var _loadError = null;
async function refresh() {
  var r = await loadList(api, '/api/admin/tasks', 'tasks');
  if (!r.ok) { _loadError = r.message; paint(); return; }
  _loadError = null;
  _tasks = r.data.tasks || [];
  paint();
}

var DOWS = [['1', 'Mon'], ['2', 'Tue'], ['3', 'Wed'], ['4', 'Thu'], ['5', 'Fri'], ['6', 'Sat'], ['7', 'Sun']];

function recurrenceLabel(t) {
  if (t.recurrence === 'daily') return 'Every day';
  if (t.recurrence === 'weekly') {
    var names = (t.dows || []).map(function (n) { var m = DOWS.find(function (d) { return d[0] === String(n); }); return m ? m[1] : n; });
    return 'Weekly · ' + names.join(', ');
  }
  if (t.recurrence === 'monthly') return 'Monthly · day ' + t.dom;
  return 'One-off · due ' + (t.due_date || '?');
}

// v126.71 (Head Office: "search easy" — extended to the manager app lists). A search
// box over the published-task list. It re-renders ONLY the #taCards container so
// the composer above is never disturbed mid-compose (and the search input keeps
// its focus/caret — it isn't re-rendered).
var _q = '';
function matchesQ(t) {
  var q = _q.trim().toLowerCase();
  if (!q) return true;
  return ((String(t.title || '') + ' ' + String(t.body || '')).toLowerCase().indexOf(q) !== -1);
}
function cardsHtml() {
  var cards = _tasks.filter(matchesQ).map(function (t) {
    var chips = (t.priority === 'urgent' ? '<span class="ta-chip u">URGENT</span>' : '') +
      (t.priority === 'high' ? '<span class="ta-chip h">HIGH</span>' : '') +
      (t.archived ? '<span class="ta-arch">ARCHIVED</span>' : '');
    var aud = t.audience === 'stores' ? ((t.stores || []).length + ' store(s)')
      : t.audience === 'country' ? ((t.countries || []).join(', ') || 'Country')   // v126.74
      : 'All stores';
    var bodyHtml = t.body
      ? '<div class="ta-body" translate="no" style="font-size:13px;color:var(--adm-comms-body);line-height:1.5;white-space:pre-wrap;word-break:break-word;margin:2px 0 8px">' + ((typeof RichText !== 'undefined' && RichText.formatRich) ? RichText.formatRich(t.body, { breaks: false }) : esc(t.body)) + '</div>'
      : '';
    return '<div class="ta-card">' +
      // v135.2: the title and the author are translate="no"; each label is its own text, so the Arabic layer can
      // swap it (one long text node never matched).
      '<div class="ta-title">' + chips + '<span translate="no">' + esc(t.title) + '</span></div>' +
      bodyHtml +
      '<div class="ta-meta"><span>' + esc(recurrenceLabel(t)) + '</span> · <span>' + esc(aud) + '</span>' +
      (t.evidence === 'photo' ? ' · <span>📷 evidence</span>' : '') + ' · <span translate="no">' + esc(t.created_by || '') + '</span>' +
      (t.edited_at ? ' · ✏️ edited' : '') + '</div>' +
      // v129.113 — one link per file. Was a single link, hard-wired to the only
      // row the schema allowed.
      attachLinksHtml(t, 'TasksAdmin.openAttachment', { className: 'ta-meta' }) +
      '<button class="ta-btn" onclick="TasksAdmin.taskCompliance(' + t.id + ')">📊 Compliance</button>' +
      (canManageTask(t) && !t.archived ? '<button class="ta-btn" onclick="TasksAdmin.startEdit(' + t.id + ')">✏️ Edit</button>' : '') +
      (canManageTask(t) ? '<button class="ta-btn" onclick="TasksAdmin.archive(' + t.id + ',' + (t.archived ? 'false' : 'true') + ')">' + (t.archived ? '↩ Restore' : '🗄 Archive') + '</button>' : '') +
      '<div id="taComp' + t.id + '" data-open="0"></div>' +
      '</div>';
  }).join('');
  return cards || '<div style="padding:24px;color:var(--tiny,#8696a0);font-size:13.5px">' +
    (_loadError ? esc(_loadError) : (_q.trim() ? 'No tasks match "' + esc(_q.trim()) + '".' : 'No tasks yet.')) + '</div>';
}
function onSearch(v) {
  _q = String(v == null ? '' : v);
  var c = document.getElementById('taCards');
  if (c) c.innerHTML = cardsHtml();
}

function paint() {
  var el = root(); if (!el) return;
  // v126.81 — audience picker: HO gets All/Country/Stores; an AM gets ONLY
  // their own area's stores, always visible, audience forced to 'stores'
  // (publish() reads _amMode; the Worker enforces the same rule).
  var audienceHtml = _amMode
    ? '<div class="ta-row" style="font-weight:700">📍 Your stores (' + esc(String((typeof currentAdmin !== 'undefined' && currentAdmin && currentAdmin.name) || 'your area')) + ')</div>' +
      '<div id="taStores" class="ta-stores" style="display:block">' +
      amStoreOptions().map(function (n) { return '<label style="display:block"><input type="checkbox" class="taStoreCb" value="' + esc(n) + '"> ' + esc(n) + '</label>'; }).join('') +
      '</div>'
    : '<div class="ta-row"><label><input type="radio" name="taAud" value="all" checked onchange="TasksAdmin.audChanged()"> All stores</label>' +
      (countryOptions().length ? '<label><input type="radio" name="taAud" value="country" onchange="TasksAdmin.audChanged()"> Country</label>' : '') +
      '<label><input type="radio" name="taAud" value="stores" onchange="TasksAdmin.audChanged()"> Selected stores</label></div>' +
      '<div id="taCountries" class="ta-row" style="display:none">' +
      countryOptions().map(function (c) { return '<label><input type="checkbox" class="taCountryCb" value="' + esc(c) + '"> ' + esc(c) + '</label>'; }).join('') +
      '</div>' +
      '<div id="taStores" class="ta-stores" style="display:none">' +
      areaChipsHtml('TasksAdmin') +
      storeOptions().map(function (n) { return '<label style="display:block"><input type="checkbox" class="taStoreCb" value="' + esc(n) + '"> ' + esc(n) + '</label>'; }).join('') +
      '</div>';
  var compose = !(_isHO || _amMode) ? '' :
    '<div class="ta-compose"><h3>' + (_editingId ? '✏️ Edit task' : '✅ New task') + '</h3>' +
    (_editingId ? '<div class="ta-meta" style="margin:-4px 0 8px">Editing — completions are kept. Files you attach here REPLACE the current files on this task; attach nothing to keep them as they are.</div>' : '') +
    '<input id="taTitle" class="ta-in" maxlength="200" placeholder="Task title">' +
    ((typeof RichText !== 'undefined' && RichText.toolbarHtml) ? RichText.toolbarHtml('taBody') : '') +
    '<textarea id="taBody" class="ta-in" maxlength="4000" placeholder="Details (optional) — **bold**, *italic*, - bullets, links auto-detect"></textarea>' +
    '<div class="ta-row">Priority: <select id="taPriority" class="ta-in" style="width:auto;margin:0"><option value="normal">Normal</option><option value="high">High</option><option value="urgent">Urgent</option></select>' +
    '<label style="margin-inline-start:auto"><input type="checkbox" id="taEvidence"> 📷 Require photo evidence</label></div>' +
    // v129.113 — `multiple`, and the picked files show as removable chips below.
    '<div class="ta-row">📎 Attach files (optional, up to ' + MAX_COMPOSE_FILES + '): <input type="file" id="taFile" multiple accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt" onchange="TasksAdmin.attachPicked(this)" style="font-size:12px">' +
    '<span style="font-size:11.5px;color:var(--tiny,#8696a0);margin-inline-start:6px">or drag them in, or paste a screenshot 📋</span>' +
    '<span id="taFileState" style="font-size:11.5px;color:var(--tiny,#8696a0);margin-inline-start:6px"></span>' +
    '<div id="taFileChips" style="flex-basis:100%">' + composeChipsHtml(_attachments, 'TasksAdmin.attachRemove') + '</div></div>' +
    '<div class="ta-row">Repeats: <select id="taRec" class="ta-in" style="width:auto;margin:0" onchange="TasksAdmin.recChanged()">' +
    '<option value="none">One-off</option><option value="daily">Daily</option><option value="weekly">Weekly</option><option value="monthly">Monthly</option></select>' +
    '<span id="taRecNone">Due: <input type="date" id="taDue" class="ta-in" style="width:auto;margin:0"></span>' +
    '<span id="taRecWeekly" style="display:none">' + DOWS.map(function (d) { return '<label style="margin-inline-end:6px"><input type="checkbox" class="taDow" value="' + d[0] + '"> ' + d[1] + '</label>'; }).join('') + '</span>' +
    '<span id="taRecMonthly" style="display:none">Day of month: <input type="number" id="taDom" min="1" max="31" class="ta-in" style="width:70px;margin:0"></span></div>' +
    '<div class="ta-row">Window (optional): <input type="date" id="taFrom" class="ta-in" style="width:auto;margin:0"> → <input type="date" id="taTo" class="ta-in" style="width:auto;margin:0"></div>' +
    audienceHtml +
    '<button class="ta-go" id="taGo" onclick="TasksAdmin.publish()">' + (_editingId ? 'Save changes' : 'Create task') + '</button>' +
    (_editingId ? '<button class="ta-btn" style="margin-inline-start:8px" onclick="TasksAdmin.cancelEdit()">Cancel</button>' : '') + '</div>';

  var board = '<div class="ta-board"><h3 style="margin:0 0 10px;font-size:15px;color:var(--brand,#009E3D)">📊 Compliance</h3>' +
    '<div class="ta-row">From <input type="date" id="taCFrom" class="ta-in" style="width:auto;margin:0"> to <input type="date" id="taCTo" class="ta-in" style="width:auto;margin:0">' +
    '<button class="ta-btn" style="margin:0" onclick="TasksAdmin.loadCompliance()">Load</button></div>' +
    '<div id="taBoard" style="margin-top:8px;font-size:12.5px;color:var(--tiny,#8696a0)">Pick a range and Load — % of due task occurrences completed, per store.</div></div>';

  // v126.71 — a search box over the list (Head Office). It re-renders ONLY #taCards
  // (via TasksAdmin.onSearch), so the composer above keeps its in-progress state.
  var searchBar = _tasks.length
    ? '<div style="margin:0 0 10px"><input id="taSearch" value="' + esc(_q) + '" oninput="TasksAdmin.onSearch(this.value)" placeholder="🔍 Search tasks…" style="width:100%;max-width:360px;padding:8px 12px;border:1px solid var(--border-strong);border-radius:8px;font-size:13px;box-sizing:border-box"></div>'
    : '';
  el.innerHTML = '<div class="ta-wrap">' + compose + board + searchBar + '<div id="taCards">' + cardsHtml() + '</div></div>';
  // v129.118 (Head Office) — drag files onto the composer. Wired on the PERSISTENT
  // root, once: paint() replaces innerHTML, so anything bound to the compose box
  // itself would be discarded on the next re-render.
  wireDropZone(el, { boxSelector: '.ta-compose', onFiles: function (files) { ingestAttachments(files); } });
}

function recChanged() {
  var v = (document.getElementById('taRec') || {}).value || 'none';
  var show = function (id, on) { var e = document.getElementById(id); if (e) e.style.display = on ? '' : 'none'; };
  show('taRecNone', v === 'none');
  show('taRecWeekly', v === 'weekly');
  show('taRecMonthly', v === 'monthly');
}
function audChanged() {
  var v = document.querySelector('input[name="taAud"]:checked');
  var val = v ? v.value : 'all';
  var box = document.getElementById('taStores');
  var countries = document.getElementById('taCountries');
  if (box) box.style.display = val === 'stores' ? 'block' : 'none';
  if (countries) countries.style.display = val === 'country' ? 'flex' : 'none';   // v126.74
}

// v126.68 — edit a published task. Load its values into the composer, flip the
// composer to edit mode (paint() reads _editingId), and scroll to it. publish()
// then PATCHes instead of POSTing. Attachment is NOT re-loaded (edit is text +
// settings; the file stays as it is on the server).
function startEdit(id) {
  var t = _tasks.find(function (x) { return x.id === id; });
  if (!t) return;
  _editingId = id;
  _attachments = []; _refused = null;
  paint();
  prefillComposer(t);
  var c = document.querySelector('#tasksAdminRoot .ta-compose');
  if (c && c.scrollIntoView) { try { c.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }
}
function cancelEdit() { _editingId = null; _attachments = []; _refused = null; paint(); }
function prefillComposer(t) {
  var set = function (id, v) { var e = document.getElementById(id); if (e) e.value = (v == null ? '' : v); };
  set('taTitle', t.title); set('taBody', t.body || ''); set('taPriority', t.priority || 'normal');
  var ev = document.getElementById('taEvidence'); if (ev) ev.checked = (t.evidence === 'photo');
  set('taRec', t.recurrence || 'none'); recChanged();
  set('taDue', t.due_date || ''); set('taDom', t.dom || '');
  var want = (t.dows || []).map(String);
  document.querySelectorAll('.taDow').forEach(function (cb) { cb.checked = want.indexOf(String(cb.value)) !== -1; });
  set('taFrom', t.valid_from || ''); set('taTo', t.valid_to || '');
  var aud = (t.audience === 'stores' || t.audience === 'country') ? t.audience : 'all';   // v126.74
  var r = document.querySelector('input[name="taAud"][value="' + aud + '"]'); if (r) r.checked = true;
  audChanged();
  var stores = t.stores || [];
  document.querySelectorAll('.taStoreCb').forEach(function (cb) { cb.checked = stores.indexOf(cb.value) !== -1; });
  var countries = t.countries || [];
  document.querySelectorAll('.taCountryCb').forEach(function (cb) { cb.checked = countries.indexOf(cb.value) !== -1; });
}

async function publish() {
  if (!refusedSendOk(_refused)) return;   // v136.71
  var rec = (document.getElementById('taRec') || {}).value || 'none';
  var dows = [];
  document.querySelectorAll('.taDow:checked').forEach(function (cb) { dows.push(Number(cb.value)); });
  var audEl = document.querySelector('input[name="taAud"]:checked');
  // v126.81 — an AM has no audience radios: always picked stores (their area).
  var audience = _amMode ? 'stores' : (audEl ? audEl.value : 'all');
  var stores = [];
  if (audience === 'stores') document.querySelectorAll('.taStoreCb:checked').forEach(function (cb) { stores.push(cb.value); });
  var countries = [];
  if (audience === 'country') document.querySelectorAll('.taCountryCb:checked').forEach(function (cb) { countries.push(cb.value); });   // v126.74
  var body = {
    title: (document.getElementById('taTitle') || {}).value || '',
    body: (document.getElementById('taBody') || {}).value || '',
    priority: (document.getElementById('taPriority') || {}).value || 'normal',
    audience: audience, stores: stores, countries: countries,
    recurrence: rec,
    due_date: (document.getElementById('taDue') || {}).value || null,
    dows: dows,
    dom: Number((document.getElementById('taDom') || {}).value) || null,
    valid_from: (document.getElementById('taFrom') || {}).value || null,
    valid_to: (document.getElementById('taTo') || {}).value || null,
    evidence: (document.getElementById('taEvidence') || {}).checked ? 'photo' : 'none',
    attachments: _attachments,   // v129.113 — the LIST (v154 sent one `attachment`)
  };
  var editing = _editingId != null;   // v126.68 — edit a published task vs create
  if (editing) body.id = _editingId;
  var btn = document.getElementById('taGo');
  if (btn) { btn.disabled = true; btn.textContent = editing ? 'Saving…' : 'Creating…'; }
  try {
    var res = await api(editing ? '/api/admin/tasks/update' : '/api/admin/tasks', { method: 'POST', body: JSON.stringify(body) });
    var d = await res.json().catch(function () { return {}; });
    if (res.ok && d && d.ok) {
      if (editing) {
        // v131.11 — the edit path gets the same file honesty as create:
        // a partial or failed save says so instead of silence (a Head Office colleague's bug).
        if (d.attachments_note) toast('Task updated — ' + d.attachments_note, 'error');
        else toast('Task updated');
        _editingId = null;
      // v125.89 — the task saved but the FILE didn't (the attachment store is
      // best-effort; a missing task_attachments table = v154 not run on this
      // environment). Say so loudly — same silent-drop class as news v125.89.
      //
      // v129.113 — the SERVER now knows exactly what happened (how many of how
      // many landed, and which migration unblocks it), so prefer its note. The
      // hardcoded v154 line stays as the fallback for a Worker that predates
      // `attachments_note`.
      } else if (d.attachments_note) {
        toast('Task created — ' + d.attachments_note, 'error');
      } else if (_attachments.length && d.task && !d.task.attachment_count) {
        toast('Task created — but the file was NOT saved. Run migrations/v154-0-task-attachments.sql on this environment, then re-attach.', 'error');
      } else {
        toast('Task created');
      }
      _attachments = []; _refused = null; refresh();
    }
    else toast((d && d.error) || (editing ? 'Could not save' : 'Could not create'), 'error');
  } catch (e) {
    toast('No connection — try again', 'error');
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = editing ? 'Save changes' : 'Create task'; }
  }
}

// v154 — attach a file to a task (Matt: admin/Task "no option for uploaded
// file"). A photo OR document, read to a data URL.
//
// v129.113 — SEVERAL of them (three Head Office colleagues, 13 Aug). `_attachments`
// is the list; the mime resolution and the 6 MB read moved to
// src/shared/attachments-ui.js, where the news composer's byte-identical copy of
// resolveMime now also lives. Files ACCUMULATE across picks — someone attaching
// a one-pager, then a planogram, should not lose the first.
var _attachments = [];
var _refused = null;   // v136.71: what the last pick refused, until a later pick replaces it
// Add file(s) to _attachments. Shared by the 📎 picker and the v126.72
// paste-a-screenshot path, so both go through the same cap + mime resolution.
//
// Re-renders ONLY the chip row, never the whole composer — a repaint here would
// wipe a half-typed task, which is the same reason v126.71's search re-renders
// only #taCards.
function paintAttachChips() {
  var box = document.getElementById('taFileChips');
  if (box) box.innerHTML = composeChipsHtml(_attachments, 'TasksAdmin.attachRemove');
  paintFileState(document.getElementById('taFileState'), _attachments.length, _refused);
}
async function ingestAttachments(fileList, fallbackName) {
  var state = document.getElementById('taFileState');
  if (state) state.textContent = 'Reading…';
  var out = await addAttachmentFiles(_attachments, fileList, fallbackName);
  _attachments = out.list;
  _refused = out.note || null;
  paintAttachChips();
  // Say what was refused. A silent drop is exactly the bug being fixed. v136.71: in red, AND
  // as a toast, because a grey line under the picker was missed.
  if (out.note) toast(out.note, 'error');
}
async function attachPicked(input) {
  await ingestAttachments(input && input.files);
  // Clear the input so picking the SAME file again still fires onchange (a
  // browser suppresses the event when the value has not changed).
  if (input) { try { input.value = ''; } catch (e) { /* older browsers */ } }
}
function attachRemove(i) {
  _attachments.splice(Number(i), 1);
  paintAttachChips();
}

// v126.72 (Head Office: "paste screenshots in task") — paste an image straight into
// the composer, same as chat (the ops manager's Snipping-Tool request). One document-
// level listener, guarded to fire ONLY when the task composer is actually
// visible (offsetParent !== null), so a paste elsewhere is never eaten. It sets
// the same _attachments list the 📎 picker does; the files attach on Create.
var _pasteBound = false;
function bindPaste() {
  if (_pasteBound || typeof document === 'undefined') return;
  _pasteBound = true;
  document.addEventListener('paste', function (e) {
    try {
      var title = document.getElementById('taTitle');
      if (!title || title.offsetParent === null) return;   // task composer not visible
      var items = (e.clipboardData && e.clipboardData.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].kind === 'file' && /^image\//.test(items[i].type || '')) {
          var f = items[i].getAsFile();
          if (!f) continue;
          e.preventDefault();
          ingestAttachments([f], 'pasted-image.png');
          if (typeof showToast !== 'undefined') showToast('📷 Screenshot pasted — it attaches when you Create the task');
          return;
        }
      }
    } catch (err) { /* a paste must never break typing */ }
  });
}
// v129.113 — `idx` picks which of the task's files to open. openFromPayload
// understands both the new list shape and the old singular one, so this works
// against a Worker that has not been redeployed yet.
async function openAttachment(taskId, idx) {
  try {
    var res = await api('/api/tasks/attachment?task_id=' + encodeURIComponent(taskId));
    if (!res.ok) { toast('Could not load the attachment', 'error'); return; }
    var d = await res.json();
    if (!d || !d.ok || !openFromPayload(d, Number(idx) || 0)) toast('Could not load the attachment', 'error');
  } catch (e) { toast('Could not load the attachment', 'error'); }
}
// v129.112 (Head Office, 13 Aug: "task - pdf file is not showing in the attachement") —
// this used to build a `data:` download anchor, which is a SILENT NO-OP for large
// files in Chrome/Edge and in iOS PWAs. The staff app fixed exactly this in
// v125.81; the fix simply never crossed to admin. Both now call ONE shared opener
// so there is no third copy to get wrong.
function openDataUrl(dataUrl, filename, contentType) {
  return openStoredFile(dataUrl, filename, contentType);
}

async function archive(id, arch) {
  try {
    var res = await api('/api/admin/tasks/archive', { method: 'POST', body: JSON.stringify({ id: id, restore: !arch }) });
    if (res.ok) { toast(arch ? 'Archived' : 'Restored'); refresh(); }
  } catch (e) { toast('Could not update', 'error'); }
}

// v126.48 — the per-store rows, shared by the all-tasks board and the per-TASK
// drill-down so the two can never render differently.
function complianceRowsHtml(c) {
  return (c.stores || []).map(function (s) {
    // v131.83 (an area manager, 17 Sep: "the compliance shows green color but 0
    // compliance. Example Spinneys completed it and could not see 1/1
    // completion").
    //
    // taskCompliance returns pct 100 when NOTHING IS DUE (due ? ... : 100), so a
    // store with no occurrences in range rendered "0/0 (100%)" behind a full
    // green bar. That reads as "perfect" when the truth is "we asked nothing of
    // this store" - the two states look identical and only one of them is good
    // news. Left unsaid, it also hides the real question, which is why the task
    // produced no occurrence in the range being looked at.
    //
    // Said plainly instead, and the bar stays empty rather than full.
    if (!s.due) {
      return '<div class="ta-store"><b>' + esc(s.store) + '</b> — nothing due in this range' +
        '<div class="ta-bar"></div></div>';
    }
    return '<div class="ta-store"><b>' + esc(s.store) + '</b> — ' + s.done + '/' + s.due + ' (' + s.pct + '%)' +
      '<div class="ta-bar"><div class="ta-fill" style="width:' + s.pct + '%"></div></div>' +
      (s.missing && s.missing.length
        ? '<div class="ta-names">Missing: <span translate="no">' + esc(s.missing.slice(0, 6).map(function (m) { return m.task + ' (' + m.date + ')'; }).join(', ')) + '</span>' + (s.missing.length > 6 ? ' <span>+' + (s.missing.length - 6) + ' more</span>' : '') + '</div>' : '') +
      '</div>';
  }).join('');
}

// v126.48 (HO feedback: "can not see compliance by task — they can see compliance
// by news article"). News drills in per ARTICLE and surveys per SURVEY; tasks only
// had the all-tasks board. This is the same view for ONE task — which stores have
// done it, which haven't, over the board's date range.
async function taskCompliance(id) {
  var slot = document.getElementById('taComp' + id);
  if (!slot) return;
  if (slot.getAttribute('data-open') === '1') {   // toggle shut
    slot.innerHTML = ''; slot.setAttribute('data-open', '0'); return;
  }
  slot.setAttribute('data-open', '1');
  slot.innerHTML = '<div class="ta-names">Loading…</div>';
  try {
    var from = (document.getElementById('taCFrom') || {}).value;
    var to = (document.getElementById('taCTo') || {}).value;
    var qs = ['id=' + encodeURIComponent(id)];
    if (from) qs.push('from=' + from);
    if (to) qs.push('to=' + to);
    var res = await api('/api/admin/tasks/compliance?' + qs.join('&'));
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok || !d || !d.ok) { slot.innerHTML = '<div class="ta-names">' + esc((d && d.error) || 'Not available') + '</div>'; return; }
    var c = d.compliance;
    slot.innerHTML = '<div style="margin-top:6px;padding-top:6px;border-top:1px solid var(--border)">' +
      '<b>' + esc(d.from) + ' → ' + esc(d.to) + ': ' + c.done + '/' + c.due + ' (' + c.pct + '%)</b>' +
      '<div style="margin-top:6px">' + (complianceRowsHtml(c) || '<span class="ta-names">No stores in scope.</span>') + '</div>' +
      '<div id="taDone' + id + '" style="margin-top:8px"><span class="ta-names">Loading who completed it…</span></div></div>';
    // v129.109 — WHO completed it, and the evidence they attached. Loaded after
    // the compliance paint so the percentages appear immediately.
    loadTaskCompletions(id, d.from, d.to);
  } catch (e) {
    slot.innerHTML = '<div class="ta-names">Could not load compliance.</div>';
  }
}


// ── v129.109 — the evidence VIEWER ──────────────────────────────────────────
// Arabian Centre asked to attach more than one photo to a task. Investigating it
// turned up something bigger: /api/tasks/photo had NO CALLER anywhere in either
// app. Head Office could tick "📷 Require photo evidence", the store was forced
// to attach one to finish, the Worker stored it — and nobody could ever look at
// it. Evidence nobody can see is not evidence.
//
// This lives inside the per-task drill-down that managers already open to check
// compliance, so the proof sits next to the percentage it explains.
async function loadTaskCompletions(id, from, to) {
  var box = document.getElementById('taDone' + id);
  if (!box) return;
  try {
    var qs = ['task_id=' + encodeURIComponent(id)];
    if (from) qs.push('from=' + encodeURIComponent(from));
    if (to) qs.push('to=' + encodeURIComponent(to));
    var res = await api('/api/admin/tasks/completions?' + qs.join('&'));
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok || !d || !d.ok) { box.innerHTML = '<span class="ta-names">Could not load completions.</span>'; return; }
    var rows = d.completions || [];
    if (!rows.length) { box.innerHTML = '<span class="ta-names">Nobody has completed this in the period.</span>'; return; }
    box.innerHTML = '<div style="font-weight:700;font-size:12px;margin-bottom:4px">Completed by</div>' +
      rows.map(function (r) {
        var who = r.staff_name ? '<span translate="no">' + esc(r.staff_name) + '</span>' : 'someone';
        var ev = r.photos
          ? '<span onclick="TasksAdmin.openEvidence(' + Number(r.id) + ')" ' +
            'style="cursor:pointer;color:var(--brand,#009E3D);font-weight:700;text-decoration:underline;margin-inline-start:6px">' +
            '📷 ' + r.photos + (r.photos === 1 ? ' file' : ' files') + '</span>'
          : '<span class="ta-names" style="margin-inline-start:6px">no evidence</span>';
        return '<div class="ta-store" style="display:flex;flex-wrap:wrap;align-items:center;gap:2px">' +
          '<b>' + esc(r.store) + '</b> — ' + who + ' · ' + esc(r.occurrence_date) + ev + '</div>';
      }).join('');
  } catch (e) {
    box.innerHTML = '<span class="ta-names">Could not load completions.</span>';
  }
}

// Fetch a completion's evidence on demand and show it full-screen. Bytes are
// never in the list — same posture as the email attachments.
async function openEvidence(completionId) {
  try {
    var res = await api('/api/tasks/photo?id=' + encodeURIComponent(completionId));
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok || !d || !d.ok) {
      if (typeof showToast !== 'undefined') showToast((d && d.error) || 'Could not open the evidence', 'error');
      return;
    }
    // Tolerant of BOTH shapes: a Worker still on the old build answers with a
    // single `photo`, the new one with a `photos` array.
    var list = Array.isArray(d.photos) && d.photos.length
      ? d.photos
      : (d.photo ? [{ photo: d.photo, filename: d.filename || null }] : []);
    if (!list.length) { if (typeof showToast !== 'undefined') showToast('No evidence on that completion', 'error'); return; }
    showEvidenceOverlay(list);
  } catch (e) {
    if (typeof showToast !== 'undefined') showToast('Could not open the evidence', 'error');
  }
}

var _evList = [];
// v129.112 — the non-image chips were `<a download>` on a data: URL, the same
// silent no-op Head Office hit on task attachments. They go through openStoredFile now.
function openEvidenceFile(i) {
  var p = _evList[i];
  if (p && p.photo) openStoredFile(p.photo, p.filename || 'evidence', null);
}

function showEvidenceOverlay(list) {
  _evList = Array.isArray(list) ? list : [];
  var ov = document.getElementById('taEvOverlay');
  if (!ov) {
    ov = document.createElement('div');
    ov.id = 'taEvOverlay';
    ov.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.82);z-index:9999;display:flex;'
      + 'align-items:center;justify-content:center;padding:16px;overflow:auto';
    ov.addEventListener('click', function (ev) { if (ev.target === ov) closeEvidence(); });
    document.body.appendChild(ov);
  }
  // v136 dark mode: the evidence viewer sits on a near-black backdrop in both themes, so its white Close and file
  // buttons and white captions are deliberate and stay as they are.
  ov.innerHTML = '<div style="max-width:940px;width:100%;display:flex;flex-direction:column;gap:10px">' +
    '<div style="display:flex;justify-content:flex-end">' +
      '<button onclick="TasksAdmin.closeEvidence()" style="border:none;background:#fff;color:#111;font-weight:800;' +
      'font-size:13px;padding:7px 14px;border-radius:9px;cursor:pointer;font-family:inherit">Close</button></div>' +
    list.map(function (p, i) {   // v133.83 (sweep I): i is the file's place in _evList, for openEvidenceFile
      var isImg = String(p.photo || '').indexOf('data:image/') === 0;
      var name = esc(p.filename || (isImg ? 'photo' : 'file'));
      return isImg
        ? '<figure style="margin:0"><img src="' + p.photo + '" alt="' + name + '" ' +
          'style="max-width:100%;border-radius:10px;display:block"><figcaption style="color:#fff;font-size:12px;' +
          'margin-top:4px" translate="no">' + name + '</figcaption></figure>'
        : '<button onclick="TasksAdmin.openEvidenceFile(' + i + ')" style="display:block;width:100%;text-align:start;' +
          'background:#fff;border:none;border-radius:10px;padding:14px;color:#0E7A5F;font-weight:700;cursor:pointer;' +
          'font-family:inherit;font-size:14px">📎 <span translate="no">' + name + '</span> — tap to open</button>';
    }).join('') + '</div>';
  ov.style.display = 'flex';
}

function closeEvidence() {
  var ov = document.getElementById('taEvOverlay');
  if (ov) { ov.style.display = 'none'; ov.innerHTML = ''; }
}

async function loadCompliance() {
  var from = (document.getElementById('taCFrom') || {}).value;
  var to = (document.getElementById('taCTo') || {}).value;
  var slot = document.getElementById('taBoard');
  if (!slot) return;
  slot.innerHTML = 'Loading…';
  try {
    var qs = [];
    if (from) qs.push('from=' + from);
    if (to) qs.push('to=' + to);
    var res = await api('/api/admin/tasks/compliance' + (qs.length ? '?' + qs.join('&') : ''));
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok || !d || !d.ok) { slot.innerHTML = esc((d && d.error) || 'Not available'); return; }
    var c = d.compliance;
    var rows = complianceRowsHtml(c);
    slot.innerHTML = '<b>' + esc(d.from) + ' → ' + esc(d.to) + ': ' + c.done + '/' + c.due + ' (' + c.pct + '%)</b>' +
      '<div style="margin-top:8px">' + (rows || '<span style="color:var(--tiny,#8696a0)">No stores in scope.</span>') + '</div>';
  } catch (e) {
    slot.innerHTML = 'Could not load compliance.';
  }
}

// v125.14 CRITICAL: handlers are EXPORTED, not on `window.TasksAdmin = {…}` —
// esbuild's `globalName:'TasksAdmin'` assigns the module EXPORTS to
// window.TasksAdmin, clobbering any in-body assignment. (See src/news for why.)
// v126.57 — tick every store in an area. Shared helper: a SNAPSHOT that ticks
// the checkboxes, not a new audience kind (see src/shared/areaPick.js).
function pickArea(areaId) { pickAreaStores('taStoreCb', areaId); }

export {
  pickArea,                              // v126.57 area quick-pick
  esc, recurrenceLabel,
  render, publish, archive, loadCompliance, taskCompliance, recChanged, audChanged,
  attachPicked, attachRemove, openAttachment,   // v129.113 — attachRemove: drop one chip
  startEdit, cancelEdit,                 // v126.68 — edit a published task
  onSearch,                              // v126.71 — search the admin task list
  openEvidence, closeEvidence, openEvidenceFile,   // v129.109 viewer; v129.112 opener
};
